import { Grid, Typography, Link, Box, Container } from "@mui/material";
import Logo from "../images/logo.png";
import FAQ from "./FAQ";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./style/theme";

const footerData = {
  Solutions: [
    { name: "Auto-scaling", href: "/auto-scaling" },
    { name: "Spot-instance", href: "/spot-instance" },
    { name: "Termination", href: "/termination" },
    { name: "Scheduling", href: "/scheduling" },
  ],
  Company: [
    { name: "About US", href: "/" },
    { name: "Get a Demo", href: "/get-started" },
    { name: "Start for Free", href: "/get-started" },
    { name: "FAQs", href: "/FAQs" },
    { name: "Terms of Service", href: "/terms" },
  ],
  Resources: [
    { name: "Privacy Policy", href: "/" },
    { name: "Cookies Policy", href: "/" },
    { name: "Documentation", href: "/" },
    { name: "Support", href: "/" },
    { name: "Release notes", href: "/" },
    { name: "Pricing", href: "/pricing" },
  ],
};

export default function Footer() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ position: "relative" }}>
        <FAQ />
        <Box
          sx={{
            backgroundColor: "primary.main",
            color: "white",
            py: 8,
            zIndex: 1,
            position: "relative",
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={{lg:18 , xs:11}}>
              <Grid item xs={12} md={4} sx={{ display: "flex", flexDirection: "column", alignItems: { xs: "center", md: "flex-start" } }}>
                <img src={Logo} alt="Logo" height="110px" />
                <Typography variant="h5" sx={{ fontWeight: "bold", mt: 1 , ml:5}}>
                  Awsmo
                </Typography>
              </Grid>
              {Object.entries(footerData).map(([section, items]) => (
                <Grid item xs={5} sm={4} md={2.5} key={section}>
                  <Typography variant='body1' sx={{ fontWeight: "bold", mb: 2 }}>
                    {section}
                  </Typography>
                  {items.map((item) => (
                    <Link
                      key={item.name}
                      href={item.href}
                      underline="none"
                      color="inherit"
                      sx={{
                        fontSize:'0.9em',
                        display: "block",
                        mb: 1,
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {item.name}
                    </Link>
                  ))}
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
